import { ApiRoutes } from '@lsq-frontend/angular-shared/app-constants';

export class FastTrackApiRoutes extends ApiRoutes {
    public static ListNotifications = 'listNotifications';
    public static AcknowledgeNotification = 'acknowledgeNotificationState';
    public static BatchAcknowledgeNotification = 'batchAcknowledgeNotificationState';
    public static ValidateEmailAddressVerificationCode = 'validateVerificationCode';
    public static ValidatePhoneNumberVerificationCode = 'validatePhoneNumberVerificationCode';
    public static ValidateUserForgotPasswordCode = 'validateUserForgotPasswordCode';
    public static SendEmailAddressVerificationCode = 'sendEmailAddressVerificationCode';
    public static SendPhoneNumberVerificationCode = 'sendPhoneNumberVerificationCode';
}
